import React, { useState,useEffect } from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link,useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import {foreignexchangelists} from '../../../apis/urls'

const EditCsiet = () => {
    
    const { id } = useParams();

    useEffect(() => {
        editlisting();
    },[]
    );



    const [res,setRes] = useState([]);
    const [type,setType] = useState('CSIT');
    const [name,setName] = useState('');
    const [visaStatus, setVisaStatus] = useState('');
    const [status, setStatus] = useState('');


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/gisapprovelist")
        
    }

    const editlisting = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: foreignexchangelists+'/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            
            setRes(response.data.data);
            //console.log(response.data.data.visa_status)
            //console.log("visasaty",res.visa_status)
            setName(response.data.data.name);
            setVisaStatus(response.data.data.visa_status);
            setStatus(response.data.data.status);

           
            
            }).catch((error) =>{
            
            console.log('error',error.message)
            

            });
    }

    const onEditForm = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const data = {
            type:type,
            name :name,
            visa_status :visaStatus,
            status :status
        }
        
        const instance = axios.create({

            baseURL: foreignexchangelists+'/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.put('',data).then((response) =>{
            
            
            navigate("/gisapprovelist")
           
          }).catch((error) =>{
            
            console.log('error',error.message)

           
            

          });
    }


    return( 
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Update Foreign Exchange Program</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard"> Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/gisapprovelist"> Programs</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Update</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                        <div className="form-wrpr">
                            <div className="card formcard small">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label className="degreehead">Name<span style={{color: "red"}}>*</span></label>
                                        <input type="text" className="form-control bg-dark dark-theme showtext" onChange={e => {setName(e.target.value)}} defaultValue={res.name} placeholder="China project Hope" id="name"></input>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            
                                            <div className="col-md-6">
                                                <label className="degreehead">Visa Status<span style={{color: "red"}}>*</span></label>
                                                    <select onChange={e => {setVisaStatus(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                                        <option>Select Visa Status</option>
                                                        <option selected="selected">F1</option>
                                                        <option>J1</option>
                                                       
                                                    </select>
                                            </div>

                                            <div className="form-group">
                                        <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                                        <select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
                                        <option value="ACTIVE">Select Status</option>
                                        <option value="ACTIVE" selected = {res.status === 'ACTIVE'}>ACTIVE</option>
                                        <option value="INACTIVE" selected = {res.status === 'INACTIVE'}>INACTIVE</option>
                                        <option value="DELETED" selected = {res.status === 'DELETED'}>DELETED</option>
                                        </select>                        
                                    </div>
                                        </div>
                                        <h6 style={{color: "red"}}>* Required Fields</h6>
                                    </div>
                                   
                                    
                                    <div className="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button onClick={onEditForm} className="btn btn-primary btn-gisa" type="button">Update</button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>



                </div>
            </aside>
        </div>
    )
}

export default EditCsiet;
